export const PENDING_NOTE_EN =
  "Marked fields correspond to pending configuration and must be completed before publishing to production.";

export const LEGAL_PAGES_EN = {
  "aviso-legal": {
    title: "Legal notice",
    description: "Legal notice of the onix-cybersecurity.tech website, owned by ARÁNDANO PARTNERS, S.L.",
    sections: [
      {
        heading: "1. Site owner",
        paragraphs: [
          "The website onix-cybersecurity.tech is owned by ARANDANO PARTNERS, S.L., with tax ID (CIF) B75419093 and registered office at Calle Camp, 2, planta 1, 08021 Barcelona, Spain. Registered in the Commercial Registry of Barcelona, section 8, sheet B-625732, entry 1. Contact email: sistemas@arandanopartners.com.",
          "ONIX CYBERSECURITY PLATFORM is a trademark owned by ARANDANO PARTNERS, S.L.",
        ],
      },
      {
        heading: "2. Purpose",
        paragraphs: [
          "The site provides corporate and commercial information about ONIX intelligence and cybersecurity products, capabilities and services. The content is general in nature and does not constitute a contractual offer, professional advice, a technical guarantee, a certification or a commitment of availability.",
        ],
      },
      {
        heading: "3. Permitted use",
        paragraphs: [
          "The user agrees to use the site lawfully, diligently and in good faith. It is forbidden to interfere with the availability or security of the site; to attempt unauthorised access; to introduce malicious code; to collect data in an automated way without permission; to impersonate identities; to infringe third-party rights; or to use the contents for unlawful activities.",
        ],
      },
      {
        heading: "4. Intellectual and industrial property",
        paragraphs: [
          "The names, signs, shields, designs, texts, interfaces, documentation and other content associated with ONIX belong to ARÁNDANO PARTNERS, S.L. or are used with the authorisation of their owners. Access to the site does not grant any licence, assignment or exploitation authorisation beyond what is strictly necessary to browse and consult its content. Copying, modifying, distributing, registering, decompiling or exploiting the contents without written authorisation is not permitted, except where expressly allowed by law.",
        ],
      },
      {
        heading: "5. Technical information and links",
        paragraphs: [
          "ARÁNDANO PARTNERS, S.L. endeavours to keep the information clear and up to date, but does not guarantee that it is free of errors or that all capabilities are available at all times, in every country, version or deployment. External links, where they exist, are provided for convenience; their content and availability are the responsibility of their respective owners.",
        ],
      },
      {
        heading: "6. Liability",
        paragraphs: [
          "To the extent permitted by law, ARÁNDANO PARTNERS, S.L. is not liable for decisions taken solely on the basis of the general information on the site, for interruptions beyond its control, for unlawful uses by third parties, or for damage arising from the user's compromised systems, devices or networks. Nothing in the foregoing limits liabilities that cannot legally be excluded.",
        ],
      },
      {
        heading: "7. Governing law and jurisdiction",
        paragraphs: [
          "This notice is governed by Spanish law. Any dispute will be subject to the courts and tribunals that are competent under the applicable regulations, without prejudice to mandatory consumer rights where applicable.",
        ],
      },
    ],
  },
  privacidad: {
    title: "Privacy policy",
    description: "Privacy policy of ONIX, a brand of ARÁNDANO PARTNERS, S.L.",
    sections: [
      {
        heading: "1. Controller",
        paragraphs: [
          "Controller: ARÁNDANO PARTNERS, S.L.",
          "Tax ID: B75419093",
          "Address: Calle Camp, 2, planta 1, 08021 Barcelona, Spain",
          "Privacy contact: sistemas@arandanopartners.com",
        ],
      },
      {
        heading: "2. Data processed",
        paragraphs: [
          "We may process the data provided by the user through the form or by direct contact: first name, surname, company, role, business email, optional phone number, area of interest, message content, and the technical data necessary to protect the form and the site.",
          "No special categories of data, nor classified, secret or sensitive information, should be sent through the form.",
        ],
      },
      {
        heading: "3. Purposes",
        list: [
          "responding to requests for information, demonstrations, partnerships or integrations;",
          "managing requested pre-contractual or contractual communications;",
          "protecting the site and preventing fraud, abuse and unauthorised access;",
          "complying with legal obligations;",
          "sending commercial communications only where valid consent or another applicable legal basis exists and a simple opt-out is offered.",
        ],
      },
      {
        heading: "4. Legal basis",
        paragraphs: [
          "The legal basis may be the data subject's consent, the application of requested pre-contractual measures, the performance of a contract, compliance with legal obligations and the legitimate interest in protecting the infrastructure and preventing abuse, depending on each processing activity.",
        ],
      },
      {
        heading: "5. Retention",
        paragraphs: [
          "Data is kept only for the time necessary to handle the request, manage the relationship and comply with applicable legal periods. Contact requests: up to 24 months from the last interaction. Security and analytics logs: 13 months maximum. Security logs are minimised and subject to limited retention.",
        ],
      },
      {
        heading: "6. Recipients and processors",
        paragraphs: [
          "Data may be processed by providers of hosting, email, security, support or form services under contract and with adequate guarantees. List of providers and, where applicable, international transfers: hosting and infrastructure providers located in the European Union or offering adequate safeguards (standard contractual clauses); no transfers outside the EEA take place without such safeguards. Personal data is not sold.",
        ],
      },
      {
        heading: "7. Rights",
        paragraphs: [
          "The data subject may request access, rectification, erasure, objection, restriction and portability where applicable, and may withdraw consent without affecting prior processing. Requests may be addressed to sistemas@arandanopartners.com, reasonably evidencing identity. Complaints may also be filed with the Spanish Data Protection Agency or another competent authority.",
        ],
      },
      {
        heading: "8. Security",
        paragraphs: [
          "We apply measures proportionate to the risk to protect data against loss, unauthorised access, alteration or disclosure. No connected system can be declared absolutely secure; we review controls and respond to incidents according to the applicable scope.",
        ],
      },
      {
        heading: "9. Minors",
        paragraphs: [
          "The site and its B2B services are not aimed at minors. Data of minors is not knowingly collected through the form.",
        ],
      },
      {
        heading: "10. Updates",
        paragraphs: [
          "This policy may be updated to reflect legal, technical or operational changes. Date of last review: 1 September 2026.",
        ],
      },
    ],
  },
  cookies: {
    title: "Cookie policy",
    description: "Cookie policy of the onix-cybersecurity.tech website.",
    sections: [
      {
        heading: "1. What cookies are",
        paragraphs: [
          "Cookies and similar technologies allow information to be remembered or functions to be executed on the user's device. By default this site only uses those necessary for security, session, preferences and requested functionality.",
        ],
      },
      {
        heading: "2. Categories",
        list: [
          "Necessary: always active because they enable essential functions.",
          "Analytics: disabled until consent; they will measure aggregated usage only if incorporated.",
          "Personalisation: disabled until consent where not necessary.",
          "Marketing: not implemented unless expressly decided, with an identified provider and valid consent.",
        ],
      },
      {
        heading: "3. Consent panel",
        paragraphs: [
          "You can accept, reject or configure cookies with equal ease from the consent banner. Non-essential scripts are not loaded before consent. You can withdraw or modify your choice at any time from the permanent “Cookie settings” link in the footer.",
        ],
      },
      {
        heading: "4. Storage table",
        paragraphs: ["The site currently only uses the following first-party technical storage:"],
        table: {
          headers: ["Name", "Provider", "Purpose", "Category", "Duration"],
          rows: [
            [
              "onix_cookie_prefs",
              "ONIX (first-party · localStorage)",
              "Store your cookie consent preferences",
              "Necessary",
              "Until revoked by the user",
            ],
          ],
        },
        paragraphsAfter: [
          "If analytics or marketing tools are incorporated in the future, this table will be updated with the actual cookies detected in production before their activation. No third-party cookies are currently used.",
        ],
      },
    ],
  },
  "terminos-de-uso": {
    title: "Terms of use",
    description: "Terms of use of the ONIX informational website.",
    sections: [
      {
        heading: "1. Scope",
        paragraphs: [
          "These terms govern access to and use of the ONIX informational website. The contracting of products, licences, pilots, integrations or services will be governed by the proposal, work order and contract signed by the parties.",
        ],
      },
      {
        heading: "2. No operational authorisation",
        paragraphs: [
          "The information on the site does not authorise the user to carry out surveillance, monitoring, testing, analysis, collection, response or access over systems, people, data or infrastructure. All operational activity requires a legal basis, the owner's authorisation, a scope, controls and an applicable contract.",
        ],
      },
      {
        heading: "3. Product descriptions",
        paragraphs: [
          "The functions described may depend on version, configuration, infrastructure, licences, sources, jurisdiction and acceptance tests. “In development”, “technical capability” and “deployment capability” do not mean general availability. ARÁNDANO PARTNERS, S.L. may modify the information without altering contracts already signed.",
        ],
      },
      {
        heading: "4. Use of materials",
        paragraphs: [
          "Consulting and printing extracts for internal, non-commercial evaluation is permitted, provided ownership notices are kept. Any reproduction, distribution, adaptation, published benchmarking, automated extraction or use of the brand requires written authorisation where the law does not establish an exception.",
        ],
      },
      {
        heading: "5. Security and reporting",
        paragraphs: [
          "Security testing against the site is not permitted without written authorisation. Potential vulnerabilities must be reported in good faith to sistemas@arandanopartners.com, without accessing third-party data, altering systems, maintaining persistence, extorting or publishing before receiving a reasonable response.",
        ],
      },
      {
        heading: "6. Suspension",
        paragraphs: [
          "Access may be restricted in the event of abuse, security risk, non-compliance or legal requirement, without prejudice to other rights.",
        ],
      },
      {
        heading: "7. Changes",
        paragraphs: [
          "Effective date: 1 September 2026. Material changes will be notified proportionately. Continued use does not replace consent where the law requires it.",
        ],
      },
    ],
  },
};
